import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { EventBus } from '@blade/common';
import { AppModule } from '@blade/common/store/app';
let default_1 = class default_1 extends Vue {
    isActive;
    get isDash() {
        return this.$route.path === '/main/dashboard';
    }
    toggleClick(e) {
        e.stopPropagation();
        this.toggleSideBar();
    }
    toggleSideBar() {
        AppModule.ToggleSideBar(false);
        EventBus.$emit('sidebar');
    }
};
__decorate([
    Prop({ default: false })
], default_1.prototype, "isActive", void 0);
default_1 = __decorate([
    Component({
        name: 'Hamburger',
    })
], default_1);
export default default_1;
